import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop, Watch} from 'vue-property-decorator'
import Api from '@/services/Api'
import _ from 'lodash'
import {BackendException, ValidationErrors} from '@/utils/HttpClient'
import {Errors} from '@/utils/Errors'

@Component
export default class Editor<ModelType extends ModelDraftType, ModelDraftType extends object> extends Vue
{
    @Inject('api')
    protected api!: Api

    @Prop({type: Object, default: () => null})
    value!: ModelDraftType | null

    @Watch('value', {immediate: true})
    onValueChange(value: ModelDraftType | null) {
        if (!_.isEqual(value, this.model)) {
            this.model = value == null ? null : {...value}
        }
    }

    model: ModelDraftType | null = null

    errors: Errors = {}

    @Watch('model')
    onModelChange(model: ModelDraftType | null) {
        if (!_.isEqual(model, this.value)) {
            this.$emit('input', {...model})
        }
    }

    @Watch('isVisible')
    onIsVisibleChange(isVisible: boolean) {
        if (!isVisible) {
            this.errors = {}
        }
    }

    get isVisible() {
        return this.value != null
    }

    showMessage(text: string) {
        this.$store.commit('addMessage', text)
    }

    finish(isSaved = false) {
        this.$emit('finish', isSaved)
    }

    async save() {
        if (!this.model) {
            return
        }

        this.errors = {}
        try {
            const savedModel = await this.saveModel(this.model)
            this.showMessage(this.getModelSavedMessage(savedModel))
            this.finish(true)
        } catch (ex) {
            if (ex instanceof ValidationErrors) {
                this.errors = ex
                this.showMessage('Исправьте ошибки и повторите сохранение')
            } else if (ex instanceof BackendException) {
                this.errors[''] = [ex.message]
                this.showMessage('Произошла ошибка на стороне сервера, повторите попытку позднее')
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async saveModel(model: ModelDraftType): Promise<ModelType> {
        throw 'Метод saveModel не реализован!'
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getModelSavedMessage(model: ModelType): string {
        return 'Объект сохранён'
    }
}